(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-okendo-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const observeOkendoWidget = () => {
    const targetNode = document.querySelector('[data-oke-widget]');
    if (!targetNode) return;

    const config = { childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
      let widgetSizeElement = document.querySelector('.js-oke-widgetSize');
      let ratingAverageElement = document.querySelector('.oke-w-ratingAverageModule-rating-average');

      if (widgetSizeElement && widgetSizeElement.innerHTML.trim() !== "" && ratingAverageElement) {
        handleOkeDomUpdates();
        observer.disconnect();
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };

  observeOkendoWidget();

function handleOkeDomUpdates() {
  const ratingAverageModule = document.querySelector('.oke-w-ratingAverageModule');
  if (ratingAverageModule) {
    const ratingStars = ratingAverageModule.querySelector('.oke-w-ratingAverageModule-rating-stars');
    const reviewCount = ratingAverageModule.querySelector('.oke-w-ratingAverageModule-count');
    const readMoreReviewsBtn = document.querySelector(".oke-showMore-button-text");
    const reviewsCountElement = document.querySelector('.oke-w-ratingAverageModule-count');

    if (reviewsCountElement) {
      reviewsCountElement.textContent = reviewsCountElement.textContent.replace('Based on', '').trim();
   }

    if (ratingStars && reviewCount) {
      reviewCount.prepend(ratingStars);
    }

    if(readMoreReviewsBtn) {
      readMoreReviewsBtn.textContent = "READ MORE REVIEWS";
    }
  }
}
});


  } catch(e) { console.error(e); }
})();
})();
